import { useTranslation } from "react-i18next";
import { features } from "@/mocks/categories";

export default function Features() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-medium text-accent-700 bg-accent-50 mb-4 whitespace-nowrap">
            {t("features.tag")}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 max-w-2xl mx-auto leading-tight">
            {t("features.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t("features.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:bg-accent-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-accent-100 transition-colors">
                <i className={`${item.icon} text-xl text-foreground-700 group-hover:text-accent-600 transition-colors`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-tight">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}